import { List as ImmutableList, OrderedSet } from 'immutable';
import { DATE } from 'customer-data-objects/property/PropertyTypes';
import { EQ, IN } from 'reporting-data/constants/operators';
import { getReportDimensions } from 'reporting-data/report/reportGetters';
// @ts-expect-error Untyped import
import { get as isUnified } from 'reporting-data/retrieve/unified/supported';
import { isConfigReport, isCustomWidgetReport } from 'reporting-data/tsTypes/reportTypes';
import { EMAIL, UNIFIED_ADS_CAMPAIGNS, UNIFIED_ADS_NETWORKS } from 'reporting-data/constants/dataTypes';
import { getDataType } from '../viewerLogic';
import { getOperatorsForPropertyType } from 'reporting-ui-components/components/filterOperators/PropertyTypeToOperator';
export const DEFAULT_TABLE_LIMIT_FOR_CHECKBOX_TABLE = 10;
const CHECKBOX_UNSUPPORTED_DATA_TYPES = [EMAIL, UNIFIED_ADS_CAMPAIGNS, UNIFIED_ADS_NETWORKS];
export const hasCheckboxTableSupport = report => !CHECKBOX_UNSUPPORTED_DATA_TYPES.includes(getDataType(report)) && !isCustomWidgetReport(report);
export const getFilterValuesFromFilterForCheckboxTable = filter => {
  let selectedFilterValues = [];
  if (filter.get('operator') === EQ) {
    const filterValue = filter.get('value');
    if (filterValue) {
      selectedFilterValues = filterValue.toString().split(' OR ');
    }
  } else {
    const maybeFilterValues = filter.get('values');
    selectedFilterValues = maybeFilterValues ? maybeFilterValues.toJS() : [];
  }
  return selectedFilterValues;
};
export const getCustomFiltersFromTableReport = tableReport => isConfigReport(tableReport) ? tableReport.getIn(['config', 'filters', 'custom'], ImmutableList([])) : ImmutableList([]);
export const getIsUnifiedAnalyticsReport = tableReport => {
  const reportDataType = getDataType(tableReport);
  return isUnified(reportDataType);
};
export const getIsUAReportWithBreakdownDimension = (tableReport, selectedDimension) => {
  if (!isConfigReport(tableReport)) {
    return false;
  }
  return getIsUnifiedAnalyticsReport(tableReport) && selectedDimension === 'breakdown';
};
export const getFilterOperatorForCheckboxTable = (selectedFilterName, dimensionMetaData) => {
  const propertyTypeForSelectedDimension = dimensionMetaData.getIn([selectedFilterName, 'type']) || dimensionMetaData.getIn([selectedFilterName, 'fieldType']);
  const operatorSetForSelectedDimension = getOperatorsForPropertyType(propertyTypeForSelectedDimension) || OrderedSet.of();
  const operatorsForSelectedDimension = operatorSetForSelectedDimension.map(operator => operator.toString());

  // use IN/EQ in checkbox table because selecting no checkboxes should select all rows
  if (operatorsForSelectedDimension.has('WildCardEqual') || operatorsForSelectedDimension.has('Equal')) {
    return EQ;
  } else if (operatorsForSelectedDimension.has('In')) {
    return IN;
  } else {
    // returning IN on default because if you return undefined the filter editor crashes. Returning IN just throws warning
    return IN;
  }
};
export const getReportDimensionForCheckboxTable = (report, dimensionMetaData, selectedDimension) => {
  const selectedDimensionDataType = dimensionMetaData.getIn([selectedDimension, 'fieldType'], '');
  const reportDimensions = getReportDimensions(report);
  const isUAReportWithBreakdownDimension = getIsUAReportWithBreakdownDimension(report, selectedDimension || '');
  const firstNonDateDimension = dimensionMetaData.size ? dimensionMetaData.find(propMetaData => propMetaData.get('fieldType') !== DATE) : undefined;
  const defaultSelectedDimension = isUAReportWithBreakdownDimension ? 'breakdown' : firstNonDateDimension && firstNonDateDimension.get('name');
  if (selectedDimension !== 'breakdown' && selectedDimensionDataType === DATE || !!selectedDimension && !reportDimensions.includes(selectedDimension)) {
    return null;
  } else if (!selectedDimension) {
    return defaultSelectedDimension;
  }
  return selectedDimension;
};
export const processListOfCheckedRowsFromFilterValues = (tableConfig, selectedFilterName, dimensionMetaData) => {
  const selectedDimension = selectedFilterName === 'filters' ? 'breakdown' : selectedFilterName;
  const isUAReportWithBreakdownDimension = getIsUAReportWithBreakdownDimension(tableConfig, selectedDimension);
  const filterOperator = getFilterOperatorForCheckboxTable(selectedFilterName, dimensionMetaData);
  const customFilters = getCustomFiltersFromTableReport(tableConfig);
  const selectedFilterIndex = customFilters.findIndex(filter => !!filter && filter.get('property') === selectedFilterName && (filter.get('operator') === filterOperator || isUAReportWithBreakdownDimension));
  const isFilterInReport = selectedFilterIndex !== -1;
  const selectedFilterValues = isFilterInReport ? getFilterValuesFromFilterForCheckboxTable(customFilters.get(selectedFilterIndex)) : [];
  return selectedFilterValues;
};